var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./top-story.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-55263c8f\"}!../../../node_modules/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./top-story.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/the-do/top-story.vue
// module id = 210
// module chunks = 0